import ReactDOM from "react-dom/client";
import VipCustomerForm from "@/components/VipCustomerForm";

ReactDOM.createRoot(document.getElementById("cbs-vip-form")!).render(<VipCustomerForm />);
